import {
  CSSProperties,
  // ElementRef,
  // useCallback,
  useContext,
  useEffect,
  useMemo,
  // useRef,
  useState,
} from 'react'

import {
  CardLink,
  PostImagePreview,
  SourceList,
  VerifiedTag,
} from '@hhgtech/hhg-components'
// import { DISCOVER_PATHS } from 'api/paths'
// import { getCommentById } from 'api/services'
// import { Loading } from 'components/atoms/loading'
// import {
//   AuthConfigContextProvider,
//   useAuthRequiredAction,
// } from 'hooks/useAuthRequiredAction'
import {
  DEFAULT_AVATAR_IMG,
  DEFAULT_LOCALE,
  // ENV,
  TRACKING_CATEGORY,
} from 'interfaces/constants'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'
import { lazyLoadInstance } from 'utils/lazyLoad'

// import { StyledInputCommentBar } from '../cardPost/index.styled'
import { likeUnlikeComment } from '../common/TogetherDataWrapper/utils/commentHelper'
import { InputCommentBar } from '../inputCommentBar'
import { Comment, Post, CardReactionType } from '../interfaces/types'
import {
  getCurrentBaseUrl,
  // getWebsiteUrlApi
} from '../utils'
import {
  decodeCommentBody,
  // likeUnlikeComment
} from '../utils/commentHelper'
// import { decodeMention, decodePostUrl } from '../utils/post'
// import { CardReplyPopover } from './cardReplyPopover'
import {
  StyledCardAuthorWrapper,
  StyledCardPost,
  StyledCardPostInner,
  StyledCardReactions,
  StyledCardReplyChild,
  StyledInputCommentBarWrapper,
  StyledInputEditCommentBarWrapper,
  StyledMoreLink,
  StyledPostContent,
  StyledSocialPreview,
} from './index.styled'

export type Props = {
  className?: string
  style?: CSSProperties
  type?: 'comment' | 'reply' | 'most-engaging'
  level?: number
  replyingId?: string
  // communitySlug?: string
  comment: Comment
  onPostCommentSuccess?: (c: Comment) => void
  onEditCommentSuccess?: (c: Comment) => void
  onOpenEditInput?: () => void
  onViewMoreCommentClick?: (post: Post) => void
  refetchComment?: (c: Comment) => void
  post?: Post
  onDeleteComment?: () => void
  isMiniStyle?: boolean
  onClick?: (e: Event) => void
  hasShare?: boolean
  isMobile?: boolean
  handleRedirectSSO?: () => void
}

const COMMENT_LIMIT = 4

const CardReply = ({
  className,
  style,
  comment: CommentProps,
  type = 'comment',
  level = 0,
  replyingId,
  onPostCommentSuccess,
  // onEditCommentSuccess,
  onOpenEditInput,
  post,
  // onDeleteComment,
  onViewMoreCommentClick,
  // communitySlug,
  refetchComment,
  isMiniStyle = false,
  isMobile,
  handleRedirectSSO,
}: Props) => {
  // const { NEXT_PUBLIC_SSO: SSO_URL } = ENV
  const { formatMessage: f } = useIntl()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  const [comment, setComment] = useState<Comment>(CommentProps || null)
  // const [editCommentLoading, setEditCommentLoading] = useState(false)
  const [showEditInputComment] = useState(false)

  useEffect(() => {
    setComment(CommentProps)
  }, [CommentProps])

  useEffect(() => {
    showEditInputComment && onOpenEditInput?.()
  }, [showEditInputComment])

  const {
    id,
    // countReplies,
    countLikes,
    content,
    createdAt,
    replies,
    images = [],
    author,
    liked,
    link,
    mentionedUser,
    mentions,
  } = comment
  const { text, replyingTo } = decodeCommentBody(content)
  const { locale = DEFAULT_LOCALE, push } = useRouter()
  const { state } = useContext(AppContext)
  const { userInfo } = state
  const communitySlug = post?.community?.slug
  const postHref = `/${communitySlug}/${post?.slug}`
  // const siteUrl = getWebsiteUrlApi(locale)
  // const { authActionWrapper } = useAuthRequiredAction(
  //   communitySlug
  //     ? {
  //         _joinCommunityIds: [post?.community?.id],
  //         _joinTopicIds: post?.topics?.map((t) => t.id),
  //         _location: postHref,
  //       }
  //     : undefined,
  // )
  // const inputEditCommentRef = useRef<ElementRef<typeof InputCommentBar>>(null)
  const [maxRepliesShow] = useState(COMMENT_LIMIT)
  const isCommented = userInfo?.id
    ? replies.some((c) => c.author.id === userInfo.id)
    : false

  const addNewReply = (comment: Comment) => {
    setComment((old) => {
      // somehow this set state run twice
      // => we need to check unique comment id before add to array
      if (!old.replies.find((c) => c.id === comment.id)) {
        old.replies.unshift(comment)
        const newComment = {
          ...old,
          replies: old.replies.slice(),
          countReplies: old.countReplies + 1,
        }
        refetchComment?.(newComment)
        return newComment
      }
      return old
    })
  }
  const [showInputComment, setShowInputComment] = useState(false)

  const sortedReplies = useMemo(() => {
    if (type !== 'comment' || !replies || replies.length == 0) return replies
    return replies.sort((a, b) => {
      const timeA = new Date(a.createdAt).getTime()
      const timeB = new Date(b.createdAt).getTime()
      if (timeA > timeB) return -1
      if (timeA < timeB) return 1

      return 0
    })
  }, [type, replies])
  useEffect(() => {
    if (lazyLoadInstance) {
      lazyLoadInstance.update()
    }
  }, [])

  const mergeCountReplies = replies?.length || 0
  const hasPopover =
    String(author?.email) &&
    userInfo?.email &&
    String(author?.email) === String(userInfo?.email)

  const isAnonymousOfCurAuthor =
    post?.isAnonymous && post?.author?.username === author?.username
  const name = isAnonymousOfCurAuthor
    ? f({
        id: 'cardPost.anonymous',
        defaultMessage: 'Anonymous',
      })
    : author?.name || author?.username || ''
  const avatar = isAnonymousOfCurAuthor ? DEFAULT_AVATAR_IMG : author?.avatar
  const username = isAnonymousOfCurAuthor
    ? f({
        id: 'cardPost.anonymous',
        defaultMessage: 'Anonymous',
      })
    : author?.username || author?.name || ''
  const listMentions = [
    ...(post?.isAnonymous
      ? [
          {
            id: post?.author?.id || 0,
            name: f({
              id: 'cardPost.anonymous',
              defaultMessage: 'Anonymous',
            }),
          },
        ]
      : []),
    ...(mentions || []),
  ]

  const seeMoreProps = {
    'data-event-category': TRACKING_CATEGORY,
    'data-event-action': 'See More Comment Click',
    'data-event-label': getCurrentBaseUrl(locale) + postHref,
  }

  const isChatbotAuthor = comment?.author?.type === 'chatbot'

  // const handleEditComment = useCallback(async (commentId) => {
  //   setShowInputComment(false)
  //   // setEditCommentLoading(true)
  //   // await getCommentById(siteUrl, commentId).then((res) => {
  //   //   setShowEditInputComment(true)
  //   //   setTimeout(() => {
  //   //     inputEditCommentRef?.current?.setValue(
  //   //       decodeMention(
  //   //         decodePostUrl(res?.data?.content || 'abc' || '', 'edit'),
  //   //         comment?.mentions,
  //   //       ),
  //   //     )
  //   //   })
  //   // })
  //   // setEditCommentLoading(false)
  // }, [])

  return (
    // <AuthConfigContextProvider
    //   defaultParams={
    //     communitySlug
    //       ? {
    //           _joinCommunityIds: [post?.community?.id],
    //           _joinTopicIds: post?.topics?.map((t) => t.id),
    //           _location: `/${communitySlug}/${post?.slug}`,
    //         }
    //       : undefined
    //   }
    // >
    <>
      {/* {editCommentLoading && <Loading />} */}
      <StyledCardPost
        className={className}
        style={style}
        data-is-reply={!!level}
        data-is-mini-style={isMiniStyle}
      >
        {showEditInputComment ? (
          <StyledInputEditCommentBarWrapper data-is-mini-style={isMiniStyle}>
            {/* <StyledInputCommentBar
              key={'edit-' + comment?.id}
              isMobile={isMobile}
              ref={inputEditCommentRef}
              onClose={() => setShowEditInputComment(false)}
              onPostSuccess={(comment) => {
                setShowEditInputComment(false)
                onEditCommentSuccess && onEditCommentSuccess(comment)
              }}
              onPopupClose={() => setShowEditInputComment(false)}
              post={post}
              isEdit={true}
              isReply={!!level}
              commentId={comment?.id}
              imageFiles={comment?.images || []}
            /> */}
          </StyledInputEditCommentBarWrapper>
        ) : (
          <StyledCardPostInner>
            <StyledCardAuthorWrapper
              authorProps={{
                isAnonymous: Boolean(isAnonymousOfCurAuthor),
                avatar: avatar,
                name: name,
                username: username,
                email: author?.email,
                time: createdAt,
                // community: community}
                // miniIcon="./svg/icon-tag.svg"
                // authorLabelType: getAuthorLabelFromRoles(author?.role || [])}
                className: `post-author ${hasPopover ? 'with-popover' : ''}`,
                type: type,
                userType: author?.type,
                title: author?.title,
                userId: author?.id,
                role: author?.role,
                expertId: author?.partnerId,
                url: '',
                hideBackground: author?.type === 'chatbot',
                avatarProps: {
                  size: isMobile ? 24 : 40,
                },
                badgeIconSize: isMobile ? 12 : 15,
                // author?.email === userInfo?.email
                //   ? SSO_URL + DISCOVER_PATHS.GET_PROFILE
                //   : '',
              }}
            >
              {/* {hasPopover && (
                <CardReplyPopover
                  onDeleteComment={onDeleteComment}
                  className="popover"
                  commentId={comment.id}
                  onEditComment={() => handleEditComment(comment.id)}
                />
              )} */}
            </StyledCardAuthorWrapper>
            {Boolean(comment?.isVerify) && !Boolean(comment?.isOppose) && (
              <VerifiedTag
                title={comment?.userVerify?.title}
                name={comment?.userVerify?.name}
                userId={comment?.userVerify?.id}
                role={comment?.userVerify?.role}
                avatar={comment?.userVerify?.avatar}
              />
            )}
            <StyledPostContent
              className="post-content-wrapper"
              replyingTo={replyingTo}
              mentionedUser={mentionedUser}
              description={text}
              mentions={listMentions}
            />
            <StyledSocialPreview>
              {images && images.length > 0 ? (
                <div
                  key="image-preview"
                  className="image-preview-wrapper"
                  data-is-reply={true}
                >
                  <PostImagePreview
                    images={images}
                    authorName={author?.username}
                    isSensitive={Boolean(comment?.isSensitive)}
                  />
                </div>
              ) : null}
              {(!images || images.length === 0) && link ? (
                <div
                  key="link-preview"
                  className="link-preview-wrapper"
                  data-is-reply={true}
                >
                  <CardLink url={link} />
                </div>
              ) : null}
            </StyledSocialPreview>
          </StyledCardPostInner>
        )}

        {type !== 'most-engaging' ? (
          <>
            {isChatbotAuthor && post?.isAskDoctor && (
              <SourceList
                listUrl={comment?.source}
                categorySlug={comment?.categorySlug}
              />
            )}
            <StyledCardReactions
              trackingCategory={TRACKING_CATEGORY}
              trackingLabel={getCurrentBaseUrl(locale) + postHref}
              type={CardReactionType.reply}
              loveCount={countLikes}
              replyCount={mergeCountReplies}
              className="post-reaction"
              liked={liked}
              isReplied={!isCommented}
              hasShare={false}
              hasSave={false}
              hideCommentIcon={isChatbotAuthor}
              onCommentClick={() => setShowInputComment((v) => !v)}
              onCommentCountClick={() => {
                // authActionWrapper(
                //   () => {
                //     setShowInputComment(true)
                //   },
                //   { action: 'reply-comment' },
                // )
              }}
              onLikeClick={() => {
                !isLoggedIn
                  ? handleRedirectSSO?.()
                  : (async () => {
                      if (id) {
                        const res = await likeUnlikeComment({
                          commentId: id,
                          setLike: !liked,
                          locale,
                        })
                        if (res.status === 1) {
                          setComment((old) => {
                            return {
                              ...old,
                              liked: !liked,
                              countLikes: old.countLikes + (!liked ? 1 : -1),
                            }
                          })
                        }
                      }
                    })()
                // authActionWrapper(
                //   async () => {
                //     if (id) {
                //       const res = await likeUnlikeComment({
                //         commentId: id,
                //         setLike: !liked,
                //         locale,
                //       })
                //       if (res.status === 1) {
                //         setComment((old) => {
                //           return {
                //             ...old,
                //             liked: !liked,
                //             countLikes: old.countLikes + (!liked ? 1 : -1),
                //           }
                //         })
                //       }
                //     }
                //   },
                //   { action: 'like-comment' },
                // )
              }}
            />
            {showInputComment && (
              <StyledInputCommentBarWrapper>
                <InputCommentBar
                  key={'input-comment-' + comment.id}
                  isMobile={isMobile}
                  replyingId={replyingId || comment.id}
                  replyToName={name}
                  isReply
                  onClose={() => setShowInputComment(false)}
                  onPostSuccess={(comment) => {
                    if (type === 'reply') {
                      onPostCommentSuccess && onPostCommentSuccess(comment)
                    } else {
                      addNewReply(comment)
                    }
                    setShowInputComment(false)
                  }}
                  post={post}
                  replyingUser={author}
                  btnProps={{
                    dataEventCategory: TRACKING_CATEGORY,
                    dataEventAction: 'Submit Reply Comment',
                    dataEventLabel: getCurrentBaseUrl(locale) + postHref,
                  }}
                  expandPopupProps={{
                    isMobile,
                    heading: f({
                      id: 'cardReply.inputComment.heading',
                      defaultMessage: 'Reply',
                    }),
                    note: f(
                      {
                        id: 'inputComment.replyTo',
                      },
                      {
                        name: `<span style="color: #2D87F3; cursor: pointer">@${
                          author?.name || ''
                        }</span>`,
                      },
                    ),
                  }}
                />
              </StyledInputCommentBarWrapper>
            )}
            {type === 'comment' && replies && replies.length > 0 ? (
              <div className="comment-reply-wrapper">
                {sortedReplies
                  ?.slice(0, maxRepliesShow)
                  ?.map((reply, index) => (
                    <StyledCardReplyChild key={String(reply.id) + index}>
                      <CardReply
                        isMobile={isMobile}
                        comment={reply}
                        isMiniStyle={true}
                        type="reply"
                        className="comment-reply-item"
                        level={level + 1}
                        replyingId={id}
                        onPostCommentSuccess={addNewReply}
                        post={post}
                        hasShare={false}
                        onDeleteComment={() => {
                          setComment((old) => {
                            return {
                              ...old,
                              replies: old.replies.filter(
                                (r) => r.id !== reply.id,
                              ),
                              countReplies: old.countReplies - 1,
                            }
                          })
                        }}
                        onEditCommentSuccess={(reply) => {
                          const replyIdx = comment?.replies.findIndex(
                            (i) => i.id == reply.id,
                          )
                          const tmpReplies = [...comment?.replies]
                          tmpReplies[replyIdx] = reply
                          setComment((old) => {
                            return {
                              ...old,
                              replies: tmpReplies,
                            }
                          })
                        }}
                        // communitySlug={communitySlug}
                      />
                    </StyledCardReplyChild>
                  ))}
                {/* {mergeCountReplies > maxRepliesShow && (
                  <>
                    <StyledMoreLink
                      className="more-cmt"
                      text={f(
                        {
                          id: 'comment.seeMoreReplies',
                        },
                        {
                          count: mergeCountReplies - maxRepliesShow,
                        },
                      )}
                      onClick={() =>
                        setMaxRepliesShow((m) => m + COMMENT_LIMIT)
                      }
                      {...seeMoreProps}
                    />
                  </>
                )} */}
              </div>
            ) : null}
          </>
        ) : (
          <StyledMoreLink
            className="see-more-comments"
            text={f({
              id: 'post.viewMoreComments',
            })}
            onClick={(e) => {
              e.stopPropagation()
              post && onViewMoreCommentClick
                ? onViewMoreCommentClick(post)
                : push(`/${communitySlug || '_'}/${post?.slug}`)
            }}
            {...seeMoreProps}
          />
        )}
      </StyledCardPost>
    </>
  )
}

export { CardReply }
